import classNames from "classnames";
import React, { FC } from "react";
import { Oval } from "react-loader-spinner";

import { Button } from "../Button";
import { ChevronLeftIcon } from "../SvgIcon";

interface IProps {
  isLast: boolean;
  isFirst: boolean;
  handleBackClick: () => void;
  form: string;
  isSubmitting: boolean;
  lastButtonText?: string;
  nextButtonText?: string;
  customLastButton?: React.ReactNode;
  disabled?: boolean;
  bgColor?: string;
  hideNextBtn?: boolean;
  classes?: string;
}

export const FormNavigation: FC<IProps> = ({
  isLast,
  isFirst,
  handleBackClick,
  form,
  isSubmitting,
  lastButtonText = "Submit",
  nextButtonText = "Next",
  customLastButton,
  disabled,
  bgColor = "bg-mki-blue-100",
  hideNextBtn = false,
  classes = ""
}) => {
  return (
    <section
      className={classNames(
        "w-full flex items-center relative mt-10",
        {
          "justify-end": isFirst,
          "justify-between": !isFirst
        },
        classes
      )}
    >
      {!isFirst ? (
        <Button
          borderColor="transparent"
          bgColor="transparent"
          textColor="gray-500"
          className="py-2 flex items-center font-semibold border-transparent group hover:text-gray-600 !space-x-1"
          onClick={handleBackClick}
        >
          <ChevronLeftIcon strokeColor="text-gray-500 group-hover:text-gray-700" />
          <span>Back</span>
        </Button>
      ) : null}

      {hideNextBtn ? null : customLastButton ? (
        customLastButton
      ) : (
        <Button
          type="submit"
          fontSize="lg"
          form={form}
          className={classNames(
            "px-12 h-10 font-semibold focus:outline-none p-4 hover:bg-native-300 hover:border-native-300 flex justify-center items-center",
            {
              "cursor-not-allowed bg-opacity-40": isSubmitting || disabled
            },
            bgColor
          )}
          disabled={disabled}
        >
          {isSubmitting ? (
            <Oval color="#fff" strokeWidth={5} width={15} height={15} />
          ) : isLast ? (
            lastButtonText
          ) : (
            nextButtonText
          )}
        </Button>
      )}
    </section>
  );
};
